import { render, staticRenderFns } from "./mallAdd.vue?vue&type=template&id=058f8a92&scoped=true&"
import script from "./mallAdd.vue?vue&type=script&lang=js&"
export * from "./mallAdd.vue?vue&type=script&lang=js&"
import style0 from "./mallAdd.vue?vue&type=style&index=0&id=058f8a92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f8a92",
  null
  
)

export default component.exports